import(/* webpackMode: "eager", webpackExports: ["HomePage"] */ "/vercel/path0/apps/evo/components/app/home-page.tsx");
